module.exports = {"TXTWCL_Returns":{"id":"TXTWCL_Returns","defaultMessage":"Gevinst"},"TXTWCL_n_a":{"id":"TXTWCL_n_a","defaultMessage":"-"}}